import { getParameterByName } from "../../getParameters";

export var langFilesToLoad: Array<[string, string]> = [];
export const optionalAssets: Set<string> = new Set();

let usrlang = getParameterByName("lang")?.toLowerCase() ?? null;

// Default language files — required
langFilesToLoad.push([
  "langGeneralDefault",
  "localization/langGeneral_en.json",
]);
langFilesToLoad.push(["langDefault", "localization/lang_en.json"]);

// Custom language files — optional
if (usrlang) {
  const langGeneralKey = "langGeneral";
  const langKey = "lang";
  langFilesToLoad.push([
    langGeneralKey,
    `localization/langGeneral_${usrlang}.json`,
  ]);
  langFilesToLoad.push([langKey, `localization/lang_${usrlang}.json`]);

  optionalAssets.add(langGeneralKey);
  optionalAssets.add(langKey);
} else {
  // Fallback language files — required
  langFilesToLoad.push(["langGeneral", "localization/langGeneral_en.json"]);
  langFilesToLoad.push(["lang", "localization/lang_en.json"]);
}

// Tournament language files
langFilesToLoad.push([
  "tournamentDefaultTextFile",
  "localization/tournament_en.json",
]);

if (usrlang) {
  const tournamentLangKey = "tournamentTextFile";
  langFilesToLoad.push([
    tournamentLangKey,
    `localization/tournament_${usrlang}.json`,
  ]);
  optionalAssets.add(tournamentLangKey);
} else {
  langFilesToLoad.push([
    "tournamentTextFile",
    "localization/tournament_en.json",
  ]);
}
